import React from 'react'
import { Button } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { formatMessageNew } from '@/utils/common'

const CollapseBtn = props => {
  const { filterIsCollapse, onCollapseFilter, onExpandFilter } = props
  return (
    <div>
      {filterIsCollapse ? (
        <Button type="link" onClick={onExpandFilter} className="collapseBtn">
          {formatMessageNew('languageObj.commonLocale.expand')} <DownOutlined />
        </Button>
      ) : (
        <Button type="link" onClick={onCollapseFilter} className="collapseBtn">
          {formatMessageNew('languageObj.commonLocale.collapse')} <UpOutlined />
        </Button>
      )}
    </div>
  )
}
export default CollapseBtn
